import { UpdateEvent } from "../../gui/GUIEvents"
import TextInput from "../../gui/TextInput/TextInput"
import { usePortFilter } from "../../hooks/PortFilter"

export type TSearchFilterProps = {
    search?:string
    onSearch?:(search:string) => void
}
export default function SearchFilter(props:TSearchFilterProps){
    const isManaged = props.hasOwnProperty("value")
    const {search,setSearch} = usePortFilter()
    const current = isManaged ? props.search! : search
    const onFilter = (e:UpdateEvent<string>) => {
        if (isManaged) props.onSearch?.(e.value!.toUpperCase())
        else setSearch(e.value!)
    }

    return <TextInput className="search" value={current} onUpdate={onFilter} placeholder="Search" float={true} canClear={true} inputProps={{type:"search"}}/>
}